// ./hooks/useRecognizedInstructor.js

import { useContext, useCallback } from 'react';
import { GlobalContext } from '../context/provider';
import recognizedInstructorAPI from '../api/recognizedInstructorAPI';

const useRecognizedInstructor = () => {
  const { 
    recognizedInstructorState,
    recognizedInstructorDispatch
  } = useContext(GlobalContext);
  
  // ============================================================================
  // RECOGNIZED INSTRUCTOR MANAGEMENT
  // ============================================================================

  const createRecognizedInstructor = useCallback(async (instructorData) => {
    recognizedInstructorDispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await recognizedInstructorAPI.createInstructor(instructorData);
      // console.log("create recognizedI nstructorAPI hook", response)
      if (response.success) {
        recognizedInstructorDispatch({ type: 'ADD_INSTRUCTOR', payload: response.data });
      } else {
        recognizedInstructorDispatch({ type: 'SET_ERROR', payload: response.error });
      }
      return response;
    } catch (error) {
      // console.log("create recognizedI nstructorAPI error hook", error);
      recognizedInstructorDispatch({ type: 'SET_ERROR', payload: error.message });
      throw error;
    }
  }, [recognizedInstructorDispatch]);

  const getRecognizedInstructorByEmail = useCallback(async (email) => {
    recognizedInstructorDispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await recognizedInstructorAPI.getInstructorByEmail(email);
      if (response.success) {
        recognizedInstructorDispatch({ type: 'SET_CURRENT_INSTRUCTOR', payload: response.data });
      } else {
        recognizedInstructorDispatch({ type: 'SET_ERROR', payload: response.error });
      }
      return response;
    } catch (error) {
      recognizedInstructorDispatch({ type: 'SET_ERROR', payload: error.message });
      throw error;
    }
  }, [recognizedInstructorDispatch]);

  const getAllRecognizedInstructors = useCallback(async () => {
    recognizedInstructorDispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await recognizedInstructorAPI.getAllInstructors();
      if (response.success) {
        recognizedInstructorDispatch({ type: 'LOAD_INSTRUCTORS', payload: response.data });
      } else {
        recognizedInstructorDispatch({ type: 'SET_ERROR', payload: response.error });
      }
      return response;
    } catch (error) {
      recognizedInstructorDispatch({ type: 'SET_ERROR', payload: error.message });
      throw error;
    }
  }, [recognizedInstructorDispatch]);

  const updateRecognizedInstructor = useCallback(async (email, updateData) => {
    console.log("update Recognized Instructor hook: ", updateData, email);
    
    recognizedInstructorDispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await recognizedInstructorAPI.updateInstructor(email, updateData);
      if (response.success) {
        recognizedInstructorDispatch({ type: 'UPDATE_INSTRUCTOR', payload: response.data });
      } else {
        recognizedInstructorDispatch({ type: 'SET_ERROR', payload: response.error });
      }
      console.log("update recognizedI nstructorAPI hook", response)
      
      return response;
    } catch (error) {
      console.log("update recognizedI nstructorAPI hook error", error)
      
      recognizedInstructorDispatch({ type: 'SET_ERROR', payload: error.message });
      throw error;
    }
  }, [recognizedInstructorDispatch]);

  const deleteRecognizedInstructor = useCallback(async (email) => {
    recognizedInstructorDispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await recognizedInstructorAPI.deleteInstructor(email);
      if (response.success) {
        recognizedInstructorDispatch({ type: 'DELETE_INSTRUCTOR', payload: email });
      } else {
        recognizedInstructorDispatch({ type: 'SET_ERROR', payload: response.error });
      }
      return response;
    } catch (error) {
      recognizedInstructorDispatch({ type: 'SET_ERROR', payload: error.message });
      throw error;
    }
  }, [recognizedInstructorDispatch]);

  const isRecognizedInstructor = useCallback(async (email) => {
    try {
      const response = await recognizedInstructorAPI.isRecognizedInstructor(email);
      console.log("isRecognizedInstructor2 :", response)
      
      return response;
    } catch (error) {
      console.error('Error checking recognized instructor:', error);
      return false;
    }
  }, []);

  // ============================================================================
  // UTILITY
  // ============================================================================

  const clearRecognizedInstructorData = useCallback(() => {
    recognizedInstructorDispatch({ type: 'CLEAR_INSTRUCTOR_DATA' });
  }, [recognizedInstructorDispatch]);
  return {
    // State
    instructors: recognizedInstructorState.instructors,
    currentInstructor: recognizedInstructorState.currentInstructor,
    isLoading: recognizedInstructorState.isLoading,
    error: recognizedInstructorState.error,

    // Methods
    createRecognizedInstructor,
    getRecognizedInstructorByEmail,
    getAllRecognizedInstructors,
    updateRecognizedInstructor,
    deleteRecognizedInstructor,
    isRecognizedInstructor,
    clearRecognizedInstructorData,
  };


};

export default useRecognizedInstructor;